import { render, staticRenderFns } from "./AwardWriteComponent.vue?vue&type=template&id=616dc5e8&scoped=true&"
import script from "./AwardWriteComponent.vue?vue&type=script&lang=js&"
export * from "./AwardWriteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616dc5e8",
  null
  
)

export default component.exports